export default "__VITE_ASSET__J0Xywq2t__"